module.exports = __webpack_public_path__ + "static/media/1_pl.f63e218d.png";